module.exports = __webpack_public_path__ + "img/cardiconnarrowblue.69a1017e.png";